<template>
  <v-container fluid grid-list-md ma-0 pa-0>
  <v-layout class="pa-md-4" row wrap>
      <v-flex > 
        <v-select
          v-model="domFilter"
          :items="business"
          autofocus
          label="Filter by business"
          solo          
          hint="Select your business category"
          persistent-hint
        ></v-select>
      </v-flex>
      <v-flex> 
        <v-btn  large color="primary" @click="getfilteredData">
          Search
        </v-btn>
      </v-flex>
    <v-row justify="center">
      <v-snackbar v-model="snackbar" color="accent" :timeout="timeout" bottom>
        Please use the select boxes at the top to filter templates
        <v-btn dark text @click="snackbar = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-row>

    <v-row justify="center">
     </v-row>

    <static-render :index="pageIndex" :cards="myJson" :key="pageId"></static-render>
    </v-layout>

  </v-container>
</template>

<script>
import staticSite from "@/static";
import StaticRender from "@/components/StaticRender";
export default {
  name: "ExploreStaticWebsites",
  components: {
    "static-render": StaticRender
  },
  data: () => ({
    snackbar: true,
    panel: 0,
    noArrows: false,
    timeout: 25000,
    pageIndex: 0,
    pageId: 0,
    techFilter: "Static Sites",
    domFilter: "All",
    myJson: [],
    technology: ["Wordpress", "Static Sites"],
    business: [
      "All",
      "Generic",
      "Agency",
      "Astrology",
      "Automobiles",
      "Blogging",
      "Boutique",
      "Business",
      "Charity",
      "Construction",
      "Education",
      "Fashion",
      "Freelancer",
      "Health",
      "Kids",
      "Media",
      "Photography",
      "Portfolio",
      "Products",
      "Restaurant",
      "Religion",
      "Technology",
      "Travel",
      "Wedding"
    ]
  }),
  methods: {
    getfilteredData() {
      this.pageId++;
      this.pageIndex = 0;
      this.initJson = staticSite;
      this.myJson = [];
      this.$router.replace({
        path: "/explore-static-websites",
        query: { tech: this.techFilter, dom: this.domFilter }
      });
      if (this.domFilter == "" || this.domFilter == "All") {
        this.myJson = this.initJson;
      } else {
        var filter1 = this.domFilter;
        this.myJson = this.initJson.filter(function(itm) {
          return itm.tags == filter1;
        });
      }
    }
  },
  created() {
    if (this.$route.query.dom == null && this.$route.query.tech == null)
      this.getfilteredData();
    else {
      this.techFilter = this.$route.query.tech;
      this.domFilter = this.$route.query.dom;
      this.getfilteredData();
    }
  }
};
</script>
